<template>
  <div class="page page-full clients-page">
    <div class="page-header with-actions">
      <h1>Coupons</h1>
      <div class="actions">
        <b-btn @click="createCoupon" variant="success">Create New Coupon</b-btn>
      </div>
    </div>

    <dt-datatable ref="couponsList"
                  :id="tableId"
                  url="/coupon/coupon-list"
                  :columns="columns"
                  :dt-options="dtOptions">

      <template #actions="{ data }">
        <div class="td-links-wrap">
          <a class="btn btn-link pl-0 text-success" @click="editCoupon(data.id)">Edit</a>
          <a class="btn btn-link text-danger" @click="showModalDelete(data.id)">Delete</a>
          <a class="btn btn-link" :class="{'text-danger': data.isActive, 'text-success': !data.isActive}" @click="disableOrEnable(data)">{{ data.isActive ? 'Disable' : 'Enable' }}</a>
        </div>
      </template>
    </dt-datatable>

    <coupon-create-edit-modal ref="couponCreateEditModal" @success="couponSaved"></coupon-create-edit-modal>

    <b-modal ref="modalDelete"
             cancel-variant="outline-secondary"
             ok-variant="success"
             @ok="deleteCoupon"
             title="Confirm">
      Are you sure you want to delete this coupon? This cannot be undone!
    </b-modal>
  </div>
</template>

<script>
  import { defaults } from "vue-datatables.net";

  import CouponCreateEditModal from "./coupon-create-edit-modal";

  import couponService from 'services/coupon-service';

  export default {
    name: 'CouponsList',
    components: {
      CouponCreateEditModal
    },
    data() {
      return {
        tableId: `coupons-list-id${this.$auth.id}`,
        dtOptions: {
          language: {
            ...defaults.language,
            emptyTable: "You have no coupons to manage."
          }
        },

        couponToDeleteId: null
      }
    },

    computed: {
      columns() {
        let columns = [
          { name: "Id", title: "Coupon ID", render: (data) => "#" + data },
          { name: "CreationDate", title: "Date Of Creation" },
          { name: "Code", title: "Code" },
          { name: "Redemption", title: "Redemption" },
          { name: "Type", title: "Type" },
          { name: "Actions", title: "Actions", data: false }
        ];

        return columns;
      }
    },

    methods: {
      showModalDelete(id) {
        this.couponToDeleteId = id;
        this.$refs.modalDelete.show();
      },

      async deleteCoupon() {
        await couponService.delete(this.couponToDeleteId);
        this.$root.successToast("Coupon deleted!");
        this.redrawTable();
      },

      async disableOrEnable(data) {
        await couponService.disableOrEnable(data.id);

        this.redrawTable();

        this.$root.successToast("Coupon " + (data.isActive ? "inactivated" : "activated"));
      },

      editCoupon(id) {
        this.$refs.couponCreateEditModal.show(id);
      },

      createCoupon() {
        this.$refs.couponCreateEditModal.show();
      },

      couponSaved() {
        this.redrawTable();
        this.$root.successToast('Coupon saved!');
      },

      redrawTable() {
        this.$refs.couponsList.draw(false);
      }
    }
  };
</script>